import type { PriceCalendarRenderOptions } from '../models';

export function getPriceCalendarTileRenderSize(
  priceCalendarWidth: number,
  priceCalendarHeight: number,
  tilesInColumn: number,
  options: PriceCalendarRenderOptions
): number {
  function getTileSize(
    horizontalFit: number,
    verticalFit: number,
    tilesInColumn: number,
    tilesInRow: number,
    horizontalSpace: number,
    verticalSpace: number
  ): number {
    if (horizontalFit * tilesInColumn < verticalSpace) {
      if (verticalFit * tilesInRow < horizontalSpace) {
        return Math.max(horizontalFit, verticalFit);
      }
      return Math.min(horizontalFit, verticalFit);
    } else {
      return Math.min(horizontalFit, verticalFit);
    }
  }

  const tilesInRow = 7;
  const sidePadding =
    priceCalendarWidth < options.paddingThreshold
      ? options.smallSidePadding
      : options.largeSidePadding;
  const bottomPadding =
    priceCalendarWidth < options.paddingThreshold
      ? options.smallBottomPadding
      : options.largeBottomPadding;

  const horizontalSpace = priceCalendarWidth - sidePadding;
  const verticalSpace =
    priceCalendarHeight - bottomPadding - options.headerHeight;
  const horizontalFit = Math.floor(horizontalSpace / tilesInRow);
  const verticalFit = Math.floor(verticalSpace / tilesInColumn);

  return getTileSize(
    horizontalFit,
    verticalFit,
    tilesInColumn,
    tilesInRow,
    horizontalSpace,
    verticalSpace
  );
}
